import thunkLib from "redux-thunk";

// This is a workaround for "redux-thunk" not being packaged properly to work with ES Modules (ESM).
// See https://github.com/reduxjs/redux-thunk/issues/35 and https://github.com/reduxjs/redux-toolkit/issues/1960.
// TODO: this should be fixed upstream

export default (<{ default?: typeof thunkLib }>(<any>thunkLib)).default ??
  thunkLib;
